/**
 * @generated SignedSource<<82b290543459ccfe17eca6d00d2167ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralsMetrics_referralsRef$data = {
  readonly lifetime: {
    readonly pending: number | null;
    readonly successes: number;
  };
  readonly " $fragmentType": "ReferralsMetrics_referralsRef";
};
export type ReferralsMetrics_referralsRef$key = {
  readonly " $data"?: ReferralsMetrics_referralsRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferralsMetrics_referralsRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferralsMetrics_referralsRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReferralsStats",
      "kind": "LinkedField",
      "name": "lifetime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "successes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pending",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReferralHistory",
  "abstractKey": null
};

(node as any).hash = "88f4c39acf1fcabcccb5228eca25968f";

export default node;
